import { render, staticRenderFns } from "./ThreeView.vue?vue&type=template&id=096ef2e0"
import script from "./ThreeView.vue?vue&type=script&lang=js"
export * from "./ThreeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports